'use strict'

/* -----------------------------------------------------------------------------
 * dependencies
 * -------------------------------------------------------------------------- */

// 3rd party
import { noop } from 'lodash'
import React from 'react'

// walrus
import { useComponentStates } from '../_support'

// lib
import { accessibilityRole } from '../_support'
import { BaseButtonProps, BaseButton } from '../button'
import Pressable, { PressableProps } from '../pressable'

/* -----------------------------------------------------------------------------
 * BackButton
 * -------------------------------------------------------------------------- */

export type BackButtonProps = BaseButtonProps &
  PressableProps & {
    onPress?: (event: React.SyntheticEvent) => void
    preventDefault?: boolean
  }

const BackButton = ({
  children,
  onPress,
  preventDefault,
  ...props
}: BackButtonProps) => {
  const [listeners, states, rest] = useComponentStates(props, [
    'focus',
    'hover',
    'press'
  ])

  const handlePress = props.disabled
    ? noop
    : (event: React.SyntheticEvent) => {
        // the react-navigation container professional mounted never had a
        // screen to go back to: the handler was always the whole behaviour
        if (onPress) {
          onPress(event)
        }
      }

  return (
    <Pressable {...listeners} onPress={handlePress}>
      <BaseButton
        accessibilityRole={accessibilityRole('button')}
        alignItems='center'
        justifyContent='center'
        p='12'
        {...rest}
      >
        {children}
      </BaseButton>
    </Pressable>
  )
}

export default BackButton
